import React from 'react'
import { createRoot } from 'react-dom/client'

import PWA from './pwa/index'
import { isEdge, subscribeToPushEvents, getCookieUserId } from './common/util'
import { Channel } from 'phoenix'
import '../css/pwa.scss'

let registration: ServiceWorkerRegistration | null = null

function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) {
    return
  }

  if (window.self !== window.top) {
    console.log('Loaded in frame, skipping service worker')
    return
  }

  navigator.serviceWorker
    .register('/sw.js')
    .then(r => {
      registration = r
    })
    .catch(e => console.log(e))
}

function subscribeToPush(channel: Channel) {
  const data = document.body.dataset
  const botId = JSON.parse(data.bot as string).id
  subscribeToPushEvents(data.socketUrl, botId, getCookieUserId(), registration?.pushManager, data.pushApplicationKey)
    .then(() => channel.push('user_action', { type: 'event', payload: { name: '$push_register_ok' } }))
    .catch(() => channel.push('user_action', { type: 'event', payload: { name: '$push_register_fail' } }))
}

document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.toggle('ms-edge', isEdge())

  let channel: Channel | null = null
  const props = {
    chatScreenProps: {
      onJoin(ch: Channel) {
        channel = ch
      },
      onEmit(name: string, payload: any) {
        console.log(name, payload)
        if (name === '$push_register' && channel) {
          subscribeToPush(channel)
        }
      },
    },
  }

  const root = createRoot(document.getElementById('root') as HTMLElement)
  root.render(<PWA {...props} />)

  registerServiceWorker()

  if (window.self !== window.top) {
    const handleMessage = (e: MessageEvent) => {
      const { event, payload } = e.data
      if (!event) return

      switch (event) {
        case 'js':
          eval(payload)
          break
        case 'css': {
          const styleEl = document.getElementById('host-style')
          if (styleEl) {
            styleEl.innerHTML = payload
          }
          break
        }
        case 'restart':
          setTimeout(() => document.location.reload(), 100)
          break
      }
    }
    window.addEventListener('message', handleMessage)
  }
})
